import React, { Component } from "react";
import Alert from '@mui/material/Alert';

type SpinnerProps = {
    show: boolean;
};

function Spinner({ show }: SpinnerProps) {
    if (show) {
        return <img src="/images/ajax-loader.gif" />;
    }
    return <span></span>;
}

export { Spinner };
